type Props = {
  data: any;
  type: string;
};


const Documenti = ({ data, type }: Props) => {
  const createDocsList = (data: any) => {
    return data.map((el: any) => {
      return (
        <li key={el.idDocumento}>
          <a href={el.link} target="_blank" rel="noopener noreferrer">
            {el.descrizione}
          </a>
        </li>
      );
    });
  };

  if (data?.documenti.length) {
    let inputDocs: any[] = [];
    let outputDocs: any[] = [];
    data.documenti.forEach((el: any) => {
      if (el.input) {
        inputDocs.push(el);
      } else {
        outputDocs.push(el);
      }
    });
    if (type === "input" && inputDocs.length === 0)
      return data?.documentiInputFallback;
    if (type === "output" && outputDocs.length === 0)
      return data?.documentiOutputFallback;
    return (
      <ul style={{ overflow: "hidden" }}>
        {type === "input" && createDocsList(inputDocs)}
        {type === "output" && createDocsList(outputDocs)}
      </ul>
    );
  }
  if (type === "input") return data?.documentiInputFallback;
  if (type === "output") return data?.documentiOutputFallback;
};

export default Documenti;
